/**
 * Formats a Date object to a string based on the given format type.
 * Supported formats: "dateTime", "date", "time"
 */
export function formatDateValue(date: Date, format: string): string {
  const year = date.getFullYear().toString().padStart(4, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  if (format === "dateTime") return `${year}-${month}-${day} ${hours}:${minutes}`;
  if (format === "date") return `${year}-${month}-${day}`;
  if (format === "time") return `${hours}:${minutes}`;
  return "";
}
